import { render } from "./batchSendGsSb.vue?vue&type=template&id=337403da&scoped=true"
import script from "./batchSendGsSb.vue?vue&type=script&lang=js"
export * from "./batchSendGsSb.vue?vue&type=script&lang=js"

import "./batchSendGsSb.vue?vue&type=style&index=0&id=337403da&lang=less&scoped=true"
import "./batchSendGsSb.vue?vue&type=style&index=1&id=337403da&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-337403da"]])

export default __exports__